<template>
    <span>
        <span v-if="airbnbStatus.status === 'CREATED' && !hasSyncError">
            Created
        </span>
        <span v-else-if="airbnbStatus.status === 'APPROVED' || airbnbStatus.status === 'CREATED'">
            <span v-if="hasSyncError">
                <a class="text-danger" href="#" @click="handleSyncErrorClick"
                    ><b>Sync Error</b></a
                >
            </span>
            <span v-else-if="airbnbQualityStandardStatus === PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN">
                <a class="text-warning" href="#" @click="handleNeedsAttentionClick"
                    ><b>Needs Attention</b></a
                >
            </span>
            <span v-else-if="airbnbQualityStandardStatus === PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND">
                <a class="text-danger" href="#" @click="handleSuspendedClick"
                    ><b>Suspended</b></a
                >
            </span>
            <span v-else>
                <span v-if="calendarFeedOnly == 0">Approved - Full Sync</span>
                <span v-else-if="calendarFeedOnly == 1">
                    Approved - Limited Sync
                </span>
            </span>
        </span>
        <span v-else-if="airbnbStatus.status === 'REJECTED'">
            <a class="text-danger" href="#" @click="handleRejectedClick"><b>Rejected</b></a>
        </span>
        <span v-else>Not Created</span>
    </span>
</template>

<script>
import {
    PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN,
    PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND,
} from '../../../constants';

export default {
    data() {
        return {
            feedShare: null,
            calendarFeedOnly: null,
            hasSyncError: null,
            airbnbStatus: null,
            airbnbQualityStandard: null,
            PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN,
            PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND,
        };
    },
    created() {
        this.feedShare = this.params.data;
        this.calendarFeedOnly =
            this.params.data && this.params.data.calendar_feed_only;
        this.airbnbStatus = this.params.data && this.params.data.airbnb_status;
        this.hasSyncError =
            this.params.data && this.params.data.has_sync_error;
        this.airbnbQualityStandard = this.params.data.airbnb_quality_standard;
    },
    computed: {
        airbnbQualityStandardStatus() {
            return this.airbnbQualityStandard ? this.airbnbQualityStandard.status : null;
        }
    },
    methods: {
        handleRejectedClick() {
            this.params.onRejectedClick && this.params.onRejectedClick(this.feedShare);
        },
        handleSyncErrorClick() {
            this.params.onSyncErrorClick && this.params.onSyncErrorClick(this.feedShare);
        },
        handleNeedsAttentionClick() {
            this.params.onNeedsAttentionClick && this.params.onNeedsAttentionClick(this.feedShare);
        },
        handleSuspendedClick() {
            this.params.onSuspendedClick && this.params.onSuspendedClick(this.feedShare);
        },
    },
};
</script>
